let commissionReportTableFooterOptions =  {
  showFirstLastPage: true,
  itemsPerPageOptions: [
    10, 30, 50, 100
  ]
}

export default commissionReportTableFooterOptions;
